class Api {
    constructor(setup) {
        const { fetch } = setup;
        this.setup = setup;
        this.fetch = fetch;
    }

    getHtml(url) {
        // send to google analytics
        if (typeof ga !== 'undefined') {
            ga('send', 'pageview', url);
        }
        return this.fetch(url)
            .fail(res => {
                // display ajax error page				
                if (res.getResponseHeader && res.getResponseHeader('content-type') == 'text/plain') {
                    res.responseText = '<section class="page" id="error-' + res.status + '"><pre>' + res.responseText + '</pre></section>';
                }
                __CLIENT_ROUTER.attachPage(res.responseText || res);
                __CLIENT_ROUTER.updateRoutes();
                __CLIENT_ROUTER.setActive('error-' + res.status);
            });
    }
}